import {
  ButtonBase,
  createStyles,
  Grid,
  IconButton,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import { BasePage, colors, dimensions } from 'design-system';
import { ArrowLeft, XCircle } from 'react-feather';

// Components
import DetailsHeader from '../../../Details/components/DetailsHeader';

type Props = {
  onBackRequested: () => void;
  onCloseRequested: () => void;
  loading?: boolean;
  onCreateQuotation: () => void;
};

export const BACK_ICON_SIZE = 24;
export const CLOSE_ICON_SIZE = 24;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      /** To ignore BaseEmptyPage's padding in DynamicQuotation */
      margin: -16,
      marginBottom: 0,
    },
    backIcon: {
      zIndex: 100,
      position: 'absolute',
      left: theme.spacing(2),
      top: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        left: dimensions.desktopSidePadding + BACK_ICON_SIZE,
        top: '50%',
        marginTop: -BACK_ICON_SIZE / 2.0,
      },
    },
    closeIcon: {
      position: 'absolute',
      right: theme.spacing(2),
      top: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        right: dimensions.desktopSidePadding + CLOSE_ICON_SIZE,
        top: '50%',
        marginTop: -CLOSE_ICON_SIZE / 2.0,
      },
    },
    buttonRow: {
      borderRadius: '0px 0px 20px 21px',
      height: 60,
      /** To ignore BasePage parent's div */
      margin: -8,
      width: `calc(100% + ${theme.spacing(2)}px)`,
    },
    buttonTextEnabled: {
      color: colors.white,
    },
    buttonTextDisabled: {
      color: colors.light_silver,
    },
    buttonBackgroundDisabled: {
      backgroundColor: '#F4F4F4',
    },
    buttonBackgroundEnabled: {
      backgroundColor: colors.bright_turquoise,
    },
    buttonSeparator: {
      display: 'inline-block',
      height: 40,
      width: 1,
      backgroundColor: colors.madison,
    },
    whiteText: {
      color: colors.white,
    },
  }),
);

const DynamicHeader = ({
  onBackRequested,
  onCloseRequested,
  loading,
  onCreateQuotation,
}: Props): JSX.Element => {
  const classes = useStyles();
  function createRequested(): void {
    if (!loading) {
      onCreateQuotation();
    }
  }

  return (
    <div className={classes.root}>
      <BasePage
        title={
          <DetailsHeader data-testid="details-header" position="relative" />
        }
        leftActions={
          <IconButton
            id="sales-web-back-button"
            data-testid="back-button"
            className={classes.backIcon}
            onClick={onBackRequested}
          >
            <ArrowLeft size={BACK_ICON_SIZE} color={colors.white} />
          </IconButton>
        }
        rightActions={
          <IconButton
            id="sales-web-button-close"
            data-testid="close-button"
            className={classes.closeIcon}
            onClick={onCloseRequested}
          >
            <XCircle size={CLOSE_ICON_SIZE} color={colors.white} />
          </IconButton>
        }
      >
        <Grid
          container
          className={`${classes.buttonRow} ${
            loading
              ? classes.buttonBackgroundDisabled
              : classes.buttonBackgroundEnabled
          }`}
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            data-testid="create-button-container"
            item
            xs={5}
            container
            justifyContent="center"
          >
            <ButtonBase
              id="sales-web-button-createquotation"
              data-testid="create-button"
              onClick={createRequested}
              disabled={loading}
            >
              <Typography
                variant="body2"
                className={
                  loading
                    ? classes.buttonTextDisabled
                    : classes.buttonTextEnabled
                }
              >
                CREAR COTIZACIÓN
              </Typography>
            </ButtonBase>
          </Grid>
        </Grid>
      </BasePage>
    </div>
  );
};

export default DynamicHeader;
